module.exports = __webpack_public_path__ + "static/Navbar Replacement-0daa8e0a05f06bf8fd6789c1b0bb57c9.png";